export type TestOutput = {
  hasError: boolean;
  message?: string;
  value: Record<string, string>;
};

// Websocket messages bypass the axios camelCase interceptor in api/request.ts, so the
// task's snake_case keys arrive verbatim and have to be mapped across explicitly.
type TestOutputPayload = {
  has_error?: boolean;
  message?: string;
  value?: Record<string, string>;
};

export const parseTestOutput = (rawMessage: string): TestOutput => {
  const content = (JSON.parse(rawMessage).content ?? {}) as TestOutputPayload;

  return {
    hasError: content.has_error ?? false,
    message: content.message,
    value: content.value ?? {},
  };
};
